// extracted by mini-css-extract-plugin
export default {"auditModal":"styles_auditModal__s4cUY","tableContaier":"styles_tableContaier__GBAxA","modalTitle":"styles_modalTitle__CU3gJ"};